(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('xtrm-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  function initReveal() {
    var selector = [
      'product-card:not([data-xtrm-observed])',
      '.collection-card:not([data-xtrm-observed])',
      '.featured-blog-posts-card:not([data-xtrm-observed])',
      '.media-with-content:not([data-xtrm-observed])',
      '.hero:not([data-xtrm-observed]) .hero__content'
    ].join(',');

    var targets = document.querySelectorAll(selector);

    targets.forEach(function (el, i) {
      el.setAttribute('data-xtrm-reveal', '');
      el.setAttribute('data-xtrm-observed', '');
      if (el.matches('product-card')) {
        el.style.transitionDelay = (i % 4) * 0.07 + 's';
      }
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
  });
})();
